"use client";
import { useState, useEffect } from "react";
import { apiConfig } from "../config/api.config";

function EnviarARL({ onClose, onSubmit, contratoFirmado }) {
  const [notas, setNotas] = useState("");
  const [loading, setLoading] = useState(false);
  const [rpNumero, setRpNumero] = useState(null);

  // Cargar número del RP aprobado
  useEffect(() => {
    if (!contratoFirmado?.id) return;
    const fetchRP = async () => {
      try {
        const url = apiConfig.getUrl(
          "/api/presupuesto/solicitudes/index.php",
          `contract_id=${encodeURIComponent(contratoFirmado.id)}`
        );
        const resp = await fetch(url, { credentials: "include" });
        if (!resp.ok) return;
        const data = await resp.json();
        const solicitudes = Array.isArray(data) ? data : data.solicitudes || data.data || [];
        const rp = solicitudes.find(
          (s) =>
            String(s.request_type || "").toUpperCase() === "RP" &&
            ["aprobado", "approved"].includes(String(s.response_status || "").toLowerCase())
        );
        if (rp?.numero_documento) setRpNumero(rp.numero_documento);
      } catch (e) {
        console.warn("No se pudo cargar RP:", e);
      }
    };
    fetchRP();
  }, [contratoFirmado?.id]);

  const handleEnviar = async () => {
    setLoading(true);
    try {
      await onSubmit({ notas });
    } catch (error) {
      alert("Error: " + (error.message || "Error desconocido"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: "fixed", inset: 0,
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex", justifyContent: "center", alignItems: "center",
      zIndex: 9999,
    }}>
      <div style={{
        backgroundColor: "#fff", padding: "2rem",
        borderRadius: "10px", width: "500px", maxHeight: "80vh",
        overflowY: "auto", boxShadow: "0 0 10px rgba(0,0,0,0.2)",
      }}>
        <div style={{
          display: "flex", justifyContent: "space-between",
          alignItems: "center", marginBottom: "1rem",
          paddingBottom: "0.75rem", borderBottom: "2px solid #f97316",
        }}>
          <h3 style={{ margin: 0, color: "#ea580c" }}> Solicitar ARL</h3>
          <button onClick={onClose} style={{
            background: "none", border: "none",
            fontSize: "1.5rem", cursor: "pointer", color: "#6b7280",
          }}>×</button>
        </div>

        {/* Info del contrato */}
        <div style={{
          padding: "0.75rem", backgroundColor: "#fff7ed",
          borderRadius: "0.375rem", marginBottom: "1rem",
          fontSize: "0.875rem",
        }}>
          <p style={{ margin: "0.25rem 0" }}>
            <strong>Contratista:</strong> {contratoFirmado?.nombreContratista || "N/A"}
          </p>
          <p style={{ margin: "0.25rem 0" }}>
            <strong>Radicado:</strong> {contratoFirmado?.radicado || "N/A"}
          </p>
          <p style={{ margin: "0.25rem 0" }}>
            <strong>Secretaría:</strong> {contratoFirmado?.secretaria || "N/A"}
          </p>
          <p style={{ margin: "0.25rem 0" }}>
            <strong>Objeto:</strong>{" "}
            {String(contratoFirmado?.objetoContractual || "N/A").slice(0, 120)}
            {(contratoFirmado?.objetoContractual || "").length > 120 ? "..." : ""}
          </p>

          {/* ← NÚMERO DEL RP APROBADO */}
          <p style={{ margin: "0.25rem 0" }}>
            <strong>N° RP:</strong>{" "}
            {rpNumero ? (
              <span style={{
                color: "#166534", fontWeight: 700,
                backgroundColor: "#dcfce7", padding: "2px 8px",
                borderRadius: "9999px", fontSize: "0.875rem",
              }}>
                {rpNumero}
              </span>
            ) : (
              <span style={{ color: "#9ca3af", fontStyle: "italic" }}>Cargando...</span>
            )}
          </p>
        </div>

        {/* Solo notas */}
        <div style={{ marginBottom: "1.5rem" }}>
          <label style={{
            display: "block", fontSize: "13px",
            fontWeight: 500, color: "#374151", marginBottom: "6px",
          }}>
            Notas adicionales
          </label>
          <textarea
            value={notas}
            onChange={(e) => setNotas(e.target.value)}
            rows={4}
            placeholder="Ej: Contratista requiere vinculación a ARL por inicio de obra el..."
            style={{
              width: "100%", padding: "0.5rem",
              border: "1px solid #d1d5db", borderRadius: "4px",
              fontSize: "14px", boxSizing: "border-box", resize: "vertical",
            }}
          />
        </div>

        <div style={{
          display: "flex", justifyContent: "flex-end", gap: "0.5rem",
          paddingTop: "0.75rem", borderTop: "1px solid #e5e7eb",
        }}>
          <button onClick={onClose} disabled={loading} style={{
            padding: "8px 16px", backgroundColor: "#e5e7eb",
            color: "#374151", border: "none", borderRadius: "4px",
            fontSize: "14px", cursor: "pointer",
          }}>
            Cancelar
          </button>
          <button onClick={handleEnviar} disabled={loading} style={{
            padding: "8px 16px", backgroundColor: "#f97316",
            color: "white", border: "none", borderRadius: "4px",
            fontSize: "14px", fontWeight: 500, cursor: "pointer",
          }}>
            {loading ? "Enviando..." : " Enviar solicitud ARL"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EnviarARL;